import * as Yup from 'yup';
import { TFunction } from 'i18next';
import {
  ISignUpFormField,
  ISignUpOTPFormField,
  ILoginForm,
  IForgotPasswordFormField,
  IForgotPasswordChangeField,
  IResetPasswordWithTempPasswordField,
} from 'models/login';
import { Common } from 'utils/constants';

export const LoginValidationSchema = (t: TFunction, isRecaptchaV2: boolean) => {
  return Yup.object().shape({
    email: Yup.string()
      .matches(Common.RegularExpression.EmailRegularExpression, t('login.errors.inValidEmail'))
      .required('required'),
    password: Yup.string().required('required'),
    recaptchaCode: isRecaptchaV2
      ? Yup.string().required(t('login.errors.recaptchaCode')).trim()
      : Yup.string().optional().nullable(),
  }) as unknown as Yup.SchemaOf<ILoginForm>;
};

export const ForgotPasswordSchema = (t: TFunction) => {
  return Yup.object().shape({
    email: Yup.string()
      .matches(Common.RegularExpression.EmailRegularExpression, t('login.errors.inValidEmail'))
      .required('required'),
  }) as Yup.SchemaOf<IForgotPasswordFormField>;
};

export const SignUpOTPSchema = (t: TFunction) => {
  return Yup.object().shape({
    code: Yup.string()
      .required(t('signup.errors.otpCode'))
      .trim()
      .matches(Common.RegularExpression.CodeRegularExpression, t('signup.errors.otpCode')),
  }) as unknown as Yup.SchemaOf<ISignUpOTPFormField>;
};

export const AccountMigrationOTPSchema = (t: TFunction) => {
  return Yup.object().shape({
    code: Yup.string()
      .required(t('signup.errors.otpCode'))
      .trim()
      .matches(Common.RegularExpression.CodeRegularExpression, t('signup.errors.otpCode')),
  }) as unknown as Yup.SchemaOf<ISignUpOTPFormField>;
};

export const AccountMigrationEmailSchema = (t: TFunction) => {
  return Yup.object().shape({
    email: Yup.string()
      .matches(Common.RegularExpression.EmailRegularExpression, t('login.errors.inValidEmail'))
      .required('required'),
  });
};

export const ResetPassworValidationSchema = (t: TFunction) => {
  return Yup.object().shape({
    password: Yup.string()
      .required('required')
      .matches(Common.RegularExpression.PasswordRegularExpression, t('forgot.errors.passwordFormat')),
    confirmPassword: Yup.string()
      .required('required')
      .oneOf([Yup.ref('password'), null], t('forgot.errors.confirmPasswordMatch')),
    code: Yup.string()
      .required(' ')
      .trim()
      .matches(Common.RegularExpression.CodeRegularExpression, t('forgot.errors.verificationCodeFormat')),
    email: Yup.string(),
  }) as Yup.SchemaOf<IForgotPasswordChangeField>;
};

export const SignUpValidationSchema = (t: TFunction, isRecaptchaV2: boolean) => {
  return Yup.object().shape({
    email: Yup.string()
      .matches(Common.RegularExpression.EmailRegularExpression, t('login.errors.inValidEmail'))
      .required('required')
      .max(50),
    password: Yup.string()
      .required('required')
      .matches(Common.RegularExpression.PasswordRegularExpression, t('signup.errors.passwordFormat')),
    firstName: Yup.string()
      .required('required')
      .max(20)
      .trim()
      .matches(Common.RegularExpression.GeneralNameRegularExpression, t('signup.errors.firstName')),
    lastName: Yup.string()
      .required('required')
      .max(20)
      .trim()
      .matches(Common.RegularExpression.GeneralNameRegularExpression, t('signup.errors.lastName')),
    recaptchaCode: isRecaptchaV2
      ? Yup.string().required(t('signup.errors.recaptchaCode')).trim()
      : Yup.string().optional().nullable(),
  }) as unknown as Yup.SchemaOf<ISignUpFormField>;
};

export const ResetPasswordWithTempPasswordValidationSchema = (t: TFunction) => {
  return Yup.object().shape({
    password: Yup.string()
      .required('required')
      .matches(Common.RegularExpression.PasswordRegularExpression, t('forgot.errors.passwordFormat')),
    confirmPassword: Yup.string()
      .required('required')
      .oneOf([Yup.ref('password')], t('forgot.errors.confirmPasswordMatch')),
  }) as unknown as Yup.SchemaOf<IResetPasswordWithTempPasswordField>;
};
